import React, {useEffect, useState} from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text } from "atomize";
import styled from "styled-components";
import Card from "../../Atoms/Card";
import {apiGet} from "../../../Api";
import trucateElipse from "./../../../utils/truncateElipse";
import {baseUrl} from "./../../../Constants/constants";
import {Link} from "react-router-dom";
import Skeleton from "react-loading-skeleton";


const StyledLink = styled(Link)`
  > div {
    transition: box-shadow .25s ease-in-out;
  }
  h3 {
    transition: color .25s ease-in-out;
  }
  &:hover, &:focus {
    > div {
        box-shadow: rgba(8, 11, 14, 0.06) 0px 0px 1px 0px, rgba(8, 11, 14, 0.1) 0px 16px 16px -1px;
    }
    h3 {
      color: ${theme.colors.primary};	
    }
  }
  margin-bottom: 1rem;
`;

const Organization = styled(Text)`
  color: ${theme.colors.dark};	
  font-family: Inter;	
  font-size: 12px;	
  font-weight: 500;	
  line-height: 20px;
`;

const Title = styled(Text)`
  color: ${theme.colors.dark};	
  font-family: Inter;	
  font-size: 20px;	
  font-weight: 600;	
  line-height: 32px;
`;

const Description = styled(Text)`
  color: ${theme.colors.grayDark};	
  font-family: Inter;	
  font-size: 14px;	
  line-height: 24px;
  margin-top: 1rem !important;
`;

const Image = styled.div`
  position: relative;
  width: 100%;
  height: 12rem;
  background-position: 50% 50%;
  background-repeat:   no-repeat;
  background-size:     cover;
  box-shadow: 0 0 1px 0 rgba(10,22,70,0.06), 0 6px 6px -1px rgba(10,22,70,0.1);
  border-radius: 4px;
`;

function StoriesCard(props) {
  const [data, setData] = useState(null);
  const [description, setDescription] = useState(null);
  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/node/story/${props.id}?include=field_organization,field_banner_image&jsonapi_include=1`);
      setData(result.data.data);
      let description = result.data.data.field_description;
      let regex = /(<([^>]+)>)/ig;
      description = description.replace(regex, "");
      description = trucateElipse(description, 120);
      setDescription(description);
    }
    fetchData();
  }, [props.id]);
  return (
    <>
      {data &&
      <StyledLink to={`/stories/${ encodeURI( data.title )}`}>
        <Card
          padding={'.5rem'}
          width={'450px'}
        >
          <Image style={{ backgroundImage: `url(${ data.field_banner_image.uri ? baseUrl + data.field_banner_image.uri.url : null})`}} />
          <Div
            p={'1rem'}
          >
            <Organization>
              { data.field_organization.name }
            </Organization>
            <Title
              as={'h3'}
            >
              { data.title }
            </Title>
            <Description>
              { description && description }
            </Description>
          </Div>
        </Card>
      </StyledLink>
    }
  </>
  )
}

export function LoadingStoriesCard() {
  return (
    <Card
      padding={'.5rem'}
      width={'450px'}
      style={{ width: '100%', display: 'block' }}
    >
      <Skeleton
        height={150}
      />
      <div
        style={{ margin: '.5rem 0'}}
      />
      <Skeleton
        count={4}
      />
    </Card>
  )
}

export default StoriesCard
